<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      深大南站<br>
站点介绍<br>
深大南站位于深圳市南山区白石路与高新南十道交叉路口东北侧绿化带内，车站周边规划以大学城、高新科技办公楼为主。车站为地下站，地下一层未站厅层，地下二层为站台层。共设有2个出入口。车站设有自动扶梯、垂梯、公共洗手间等便民设施。车站以白色为主色调，立柱用黄色装饰做点缀，以弧形天花吊顶为设计特色，搭配地面节奏线造型，打造出明块、轻松的空间氛围。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:16	23:56	9号线	3分50秒	5分55秒<br>
文锦	06:22	23:13	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:17	23:56	9号线	4分25秒	5分55秒<br>
文锦	06:22	23:13	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:16	00:56	9号线	4分钟	5分55秒<br>
文锦	06:22	00:13	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
高新南十道<br><br>
B出入口:<br>
白石路、桂庙新村、海滨小区、锦隆花园、深圳大学南校区实验楼<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 软件产业基地<br>
72、M562、高峰专线138、高峰专线429、高峰专线128、M109、高峰专线21、高峰专线150<br><br>
B出入口:<br>
公交站名： 深大南站<br>
M209、M528、高峰专线7<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>